'use client';

import Navbar from '@/components/layout/Navbar/Navbar';
import Footer from '@/components/layout/Footer/Footer';
import { usePathname } from 'next/navigation';

export default function AppShell({ children, comingSoon = false }) {
  const pathname = usePathname();
  const isBare = comingSoon && pathname === '/';

  if (isBare) {
    return <main className="flex-grow">{children}</main>;
  }

  return (
    <>
      <Navbar />
      <main className="flex-grow pt-20">{children}</main>
      <Footer />
    </>
  );
}
